export default __webpack_public_path__ + "static/media/i-vin_bcr.00b7911f.svg";